import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = (props) => {
  const { title, subTitle } = props;
  const pageTitle = title || "About Us";
  const crumbLabel = subTitle || pageTitle;

  return (
    <div
      style={{
        position: "relative",
        backgroundImage: "url(/images/back.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(100deg, rgba(10,20,50,0.82) 0%, rgba(13,79,138,0.70) 55%, rgba(27,116,187,0.55) 100%)",
          zIndex: 1,
        }}
      />

      {/* Decorative diagonal stripe */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "repeating-linear-gradient(115deg, transparent, transparent 60px, rgba(255,255,255,0.025) 60px, rgba(255,255,255,0.025) 61px)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      />

      {/* Decorative right circle glow */}
      <div
        style={{
          position: "absolute",
          right: "-80px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(27,116,187,0.25) 0%, transparent 70%)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      />

      {/* Content */}
      <div className="container" style={{ position: "relative", zIndex: 3 }}>
        <div className="row">
          <div className="col-12">
            <div style={{ padding: "96px 0 88px" }}>
              {/* Eyebrow tag */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "rgba(255,255,255,0.1)",
                  border: "1px solid rgba(255,255,255,0.18)",
                  borderRadius: "100px",
                  padding: "6px 16px 6px 10px",
                  marginBottom: "20px",
                  backdropFilter: "blur(6px)",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#4ab8ff",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                <Link
                  to="/"
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "rgba(255,255,255,0.75)",
                    textDecoration: "none",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                  }}
                >
                  Home
                </Link>
                <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "11px" }}>/</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#4ab8ff",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                  }}
                >
                  {crumbLabel}
                </span>
              </div>

              {/* Title */}
              <h1
                style={{
                  fontSize: "clamp(32px, 5vw, 62px)",
                  fontWeight: 800,
                  color: "#fff",
                  lineHeight: 1.15,
                  margin: "0 0 20px",
                  textShadow: "0 2px 20px rgba(0,0,0,0.3)",
                  maxWidth: "700px",
                }}
              >
                {pageTitle}
              </h1>

              {/* Accent underline */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span
                  style={{
                    display: "inline-block",
                    width: "48px",
                    height: "4px",
                    background: "#1b74bb",
                    borderRadius: "2px",
                  }}
                />
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "4px",
                    background: "#4ab8ff",
                    borderRadius: "2px",
                  }}
                />
                <span
                  style={{
                    display: "inline-block",
                    width: "6px",
                    height: "4px",
                    background: "rgba(255,255,255,0.3)",
                    borderRadius: "2px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
